import React from "react";
import { useTranslation } from "react-i18next";
import { formatDollarAmount } from "../../../../../utils/methods";

interface TableHeaderSectionProps {
  total: number;
  kpis: {
    totalAmount: string;
    totalAmountDue: string;
  };
}

const TableHeaderSection: React.FC<TableHeaderSectionProps> = ({
  total,
  kpis,
}) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-4 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-file-list-3-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('reconciliation.managerStatement.list.pageTexts.table.title')} ({total})
            </h5>
          </div>

          <div className="d-flex align-items-center">
            <span className="me-1 fw-semibold">{t('reconciliation.managerStatement.list.pageTexts.table.kpis.totalAmountDue')}:</span>
            <span className="badge bg-secondary me-2">
              {kpis.totalAmountDue ? formatDollarAmount(kpis.totalAmountDue) : '$0.00'}
            </span>

            <span className="mx-2">|</span>

            <span className="me-1 fw-semibold">{t('reconciliation.managerStatement.list.pageTexts.table.kpis.totalAmount')}:</span>
            <span className="badge bg-warning me-2">
              {kpis.totalAmount ? formatDollarAmount(kpis.totalAmount) : '$0.00'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableHeaderSection;
